import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaOuvir from '../../components/ouvidoria/desclassificadas';


function OuvidListScreen () {
    return (
        <Fragment>
            <Head titulo="Pedidos de Acesso à informação com informações desclassificadas"/>
            <Header />
            <Container>
                <ListaOuvir />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidListScreen;